import axios from "axios";

export default {

    async createEnquiry(rdata) {
        try {
            const {data} = await axios.post('/enquiry', rdata);
            return Promise.resolve(data.data)
        }catch {
            return Promise.resolve([]);
        }
    },

    async getEnquiries(dataOptions, search) {
        const requestParams = {
            page: dataOptions.page,
            limit: dataOptions.itemsPerPage,
        }
        if(search.length){
            requestParams.searchPhrase = search
        }
        try {
            const {data} = await axios.get('/enquiry', {
                params: requestParams
            });
            return Promise.resolve(data.data)
        }catch {
            return Promise.resolve([]);
        }
    },

    async getEnquiry(id) {
        try {
            const {data} = await axios.get('/enquiry/'+id);
            return Promise.resolve(data.data)
        }catch {
            return Promise.resolve([]);
        }
    }
}